import { Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { Button } from '@shared/components';

interface Props {
  onCancel: () => void;
  onConfirm: () => void;
}

const { Text } = Typography;

const RemoveChildrenModal = ({ onCancel, onConfirm }: Props) => {
  const { t } = useTranslation();
  const handleConfirm = () => {
    Modal.destroyAll();
    onConfirm();
  };

  return (
    <div>
      <Text className="mb-2 block text-center text-base font-bold">{t('childrenHealth.removed.confirm.title')}</Text>
      <Text className="block text-center text-sm text-functional-black">
        {t('childrenHealth.removed.confirm.content')}
      </Text>
      <div className="mt-4 flex w-full flex-col gap-4 lg:flex-row">
        <Button
          className="order-2 w-full border-theme-700 bg-white text-theme-700 lg:order-1 lg:w-1/2"
          key="cancel"
          onClick={onCancel}
        >
          {t('button.cancel')}
        </Button>
        <Button className="order-1 w-full lg:order-2 lg:w-1/2" key="confirm" onClick={handleConfirm}>
          {t('button.confirm')}
        </Button>
      </div>
    </div>
  );
};

export default RemoveChildrenModal;
